const rawServer = process.env.REACT_APP_SERVER_URL || "http://localhost:8001";
const server = rawServer.trim().replace(/\/+$/, "");

export default server;